/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PartNumberChangesCredentialsComponent} from './part-number-changes-credentials.component';
import {InputModule} from '../../shared/input/input.module';
import {StatusTimelineModule} from '../../shared/status-timeline/status-timeline.module';
import {PartNumberChangesDetailTitleModule} from '../part-number-changes-title/part-number-changes-detail-title.module';
import {PipesModule} from '../../shared/pipes/pipes.module';

@NgModule({
    declarations: [PartNumberChangesCredentialsComponent],
    imports: [
        CommonModule,
        InputModule,
        StatusTimelineModule,
        PartNumberChangesDetailTitleModule,
        PipesModule
    ],
    exports: [
        PartNumberChangesCredentialsComponent
    ]
})
export class PartNumberChangesCredentialsModule {
}
